// extracted by mini-css-extract-plugin
module.exports = {"base":"PressPageTitle-module-base"};